export const TRIGGER_IDS = {
  orderWebsite: 'order-a-website-button',
  firstTime: 'first-time',
};
